import React, { ChangeEvent, useEffect, useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import styles from "./AppDatePicker.scss";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import { useAppText } from "src/commun/composants/AppText";
import { de, enGB, fr } from 'date-fns/locale';
import "date-fns";
import { isValid, parse } from 'date-fns';

export type DatePickerProps = {
  name: string;
  label: string;
  value: Date | undefined;
  error?: string;
  touched?: boolean;
  fieldRef?: any;
  placeholder?: string;
  handleExternalChange?: (value: Date | undefined) => void;
  disabled?: boolean;
  onFocus?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  containerClassName?: string;
  iconVerif?: boolean;
  required?: boolean;
};

const AppDatePicker = ({
                         name,
                         label,
                         value,
                         error,
                         touched,
                         fieldRef,
                         handleExternalChange,
                         disabled,
                         className,
                         required = true
                       }: DatePickerProps) => {

  const divRef = fieldRef ? fieldRef : React.createRef<HTMLDivElement>();

  const { currentLocale } = useAppText();
  const displayError = error && touched;
  const [selectedDate, setSelectedDate] = useState<Date | null>(!value || !isValid(value) ? null : value);
  const [displayErrorMaxDate, setDisplayErrorMaxDate] = useState(false);

  useEffect(() => {
    // on init le composant avec les donnees du back qui sont en string
    if (typeof value === "string") {
      handleDayChange(parse(value, "yyyy-MM-dd", new Date()));
    }

    if (selectedDate && selectedDate.getTime() > Date.now()) {
      setDisplayErrorMaxDate(true);
    } else {
      setDisplayErrorMaxDate(false);
    }
  });


  function handleDayChange(selectedDay: Date | null) {
    if (selectedDay?.getTime() !== selectedDate?.getTime()) {
      setSelectedDate(selectedDay);
      if (handleExternalChange) {
        try {
          handleExternalChange(selectedDay && isValid(selectedDay) ? selectedDay : selectedDay?.toDateString()?.includes("Invalid Date") ? selectedDay : undefined);
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  const getPickerLocale = () => {
    switch (currentLocale) {
      case "fr":
        return fr;
      case "en":
        return enGB;
      case "de":
        return de;
      default:
        return fr;
    }
  };

  return (
    <div ref={divRef} className={styles.container}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getPickerLocale()}>
        <DatePicker
          name={name}
          label={label}
          disableFuture
          disabled={disabled}
          format="dd.MM.yyyy"
          value={selectedDate}
          onChange={handleDayChange}
          className={`${styles.datePicker} ${(displayError || displayErrorMaxDate) && styles.datePickerError} ${required && !disabled && styles.datePickerRequired} ${disabled && "btn__filter--disabled"} ${className}`}
        />
      </LocalizationProvider>
      {displayError && <AppFormErrorMessages erreurs={error}/>}
      {displayErrorMaxDate && <AppFormErrorMessages erreurs={'form.error.date.max'}/>}
    </div>
  );
}

export default AppDatePicker;